import { ITableColumn } from '@makyoapp/makyo-sdk/models/Table'

import { Cell, ICell } from '.'
import { handleImageSource } from './helpers/image'

export type TImgSourceType = 'upload' | 'random' | 'gravatar' | 'youtube' | ''

export type TImageSettings = {
  imgSourceType: TImgSourceType
  imgSourceYoutube?: string
}

export interface IImage extends ITableColumn {
  Settings: TImageSettings
}

export interface IImageCell extends ICell {
  settings: TImageSettings
  showModal: boolean
}

export class ImageCell implements IImageCell {
  value: Cell
  settings: TImageSettings
  showModal = false

  constructor(value: Cell, settings: TImageSettings) {
    this.settings = {
      imgSourceType: settings.imgSourceType,
      imgSourceYoutube: settings.imgSourceYoutube,
    }
    const youtubeSettings = this.settings
    this.value = handleImageSource(this.settings.imgSourceType, value as string, youtubeSettings.imgSourceYoutube)
  }

  toString(): string {
    if (typeof this.value === 'number') {
      return this.value.toString()
    }

    if (this.value === undefined) {
      return ''
    }

    // If the value is not a number, handle it accordingly
    if (this.value === null) {
      return ''
    }

    return String(this.value)
  }

  toCell<T extends Cell>(value: T) {
    if (typeof value !== 'string' || !value) {
      this.value = ''
      return this
    }

    if (value === null || value === undefined) {
      throw new Error('Value cannot be null or undefined')
    }

    // Return current ImageCell with updated value
    this.value = String(value)
    return this
  }

  setShowModal(show: boolean) {
    this.showModal = show
  }
}
